export enum QuickOnboardingSteps {
  WATCH_HOW_IT_WORKS = "quick_onboarding.steps.watch_how_it_works",
  CONNECT_EXCHANGE = "quick_onboarding.steps.connect_exchange",
  CREATE_BOT = "quick_onboarding.steps.create_bot",
  MONITOR_PROGRESS = "quick_onboarding.steps.monitor_progress",
}
